import { useQuery } from '@tanstack/react-query'
import { useParams } from 'react-router-dom'
import { visits as visitsApi } from '@/api/endpoints'
import { queryKeys } from '@/api/queryKeys'
import { Banner } from '@/components/Banner'
import { Spinner } from '@/components/Spinner'
import { PatientScreen } from '@/features/patient/PatientScreen'

/** `/visits/:visitId/edit` carries no patient id, so the visit is resolved
 *  first: correcting a consultation looks exactly like writing one. */
export function VisitEditRoute() {
  const { visitId = '' } = useParams()
  const visit = useQuery({
    queryKey: queryKeys.visit(visitId),
    queryFn: () => visitsApi.get(visitId),
    enabled: Boolean(visitId),
  })

  if (visit.isLoading) return <Spinner label="Loading consultation" />
  if (!visit.data) return <Banner tone="danger">That consultation could not be loaded.</Banner>

  return (
    <PatientScreen
      initialTab="consultation"
      patientIdOverride={visit.data.data.patient_id}
      visitId={visitId}
    />
  )
}
